export default "__VITE_ASSET__3f11fa39__"